import React, { ReactElement } from 'react';
import './style.scss';
import { IconName, findIcon } from 'utils/handleIcon';
import { TwoSelections } from 'views/mutual/inputRadio';
import { CardLabel } from 'views/mutual/questionCard';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';

export const ResidenceQuestionTop = () => {
  const helpIcon = findIcon(IconName.help);
  const icon = findIcon(IconName.man);

  return (
    <>
      <div className="residenceQuestionTop">
        <CardLabel
          letter="&#10103; 日本国内に住所を有しますか。"
          sentence="日本国内に住所を有しない非居住者の方は、口座開設をお受けできません。"
        />
      </div>
    </>
  );
};

interface ResidenceQuestionBottomProps {
  selected: boolean | null;
  onChange: (selected: boolean) => void;
  error: string | undefined;
}

export const ResidenceQuestionBottom = (props: ResidenceQuestionBottomProps) => {
  return (
    <>
      <div className="residenceQuestionBottom">
        <TwoSelections name="ResidenceQuestion" {...props} />
      </div>
    </>
  );
};
